import { functions } from '../firebase';
import { ProjectErrorType } from '../utils/errors/types';
import { CloudFunctionType } from './types';
import { getProjectErrorFromRawError } from '../utils/errors';
import { httpsCallable } from 'firebase/functions';

const CLOUD_FUNCTIONS_GEN_SUFFIX = 'SecondGen';
export const executeCloudFunction = async (
  cloudFunctionName: CloudFunctionType,
  params?: any,
): Promise<any | ProjectErrorType> => {
  try {
    const _function = httpsCallable(functions, cloudFunctionName + CLOUD_FUNCTIONS_GEN_SUFFIX);
    const result = await _function({
      ...(params ? params : {}),
    });
    const rawData = result?.data as any;

    if (rawData && 'error' in rawData) {
      console.log('[CLOUD FUNCTION]', cloudFunctionName, ':', rawData.error);
      return getProjectErrorFromRawError(rawData.error);
    }

    return rawData;
  } catch (error) {
    console.log('[FIREBASE ERROR]', cloudFunctionName, ':', error);
    return getProjectErrorFromRawError(error as Error);
  }
};
